import React from 'react';
import { useTranslation } from 'react-i18next';
import { Images } from 'lucide-react';

import ProjectNameHeader from '../project-name-header/ProjectNameHeader';
import { createLucideSidebarIcon } from '../../../icons/createLucideSidebarIcon';

const MediaStudioHeaderIcon = createLucideSidebarIcon(Images);

function MediaStudioHeader() {
  const { t } = useTranslation('header');
  return (
    <ProjectNameHeader
      icon={MediaStudioHeaderIcon}
      selector={() => null}
      defaultName={t('mediaStudio')}
      iconProps={{
        disableCommonStyles: true,
        disableCommonColors: true,
        style: { color: 'var(--color-primary)', fill: 'none' },
      }}
    />
  );
}

export default MediaStudioHeader;
